<template>
  <RevIllustration
    v-if="logo?.url"
    :alt="logo.description"
    :height
    image-class-names="max-w-full object-contain leading-none"
    :src="logo.url"
    :style="{ height: `${height}px`, width: 'auto' }"
    :width="height"
  />
</template>

<script setup lang="ts">
import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'
import { RevIllustration } from '@ds/components/Illustration'

defineProps<{
  height: number
  logo?: MobilePlanOffer['partner']['logo']
}>()
</script>
